import { useId, useState } from "react";
import {
  AccordionBlock,
  AccordionCard,
  AccordionContent,
  AccordionContentInner,
  AccordionLead,
  AccordionList,
  AccordionListItem,
  AccordionSection,
  AccordionSubtitle,
  AccordionText,
  AccordionTitle,
  ToggleButton,
  ToggleIcon,
} from "../AboutFapifyAccordion/AboutFapifyAccordion.styles";
import {
  HeroActions,
  PrimaryLink,
  SecondaryLink,
} from "../../screens/HomePage/HomePage.styles";
import { HOME_FAQS } from "../../seo/siteSeo.js";

const PRODUCT_HIGHLIGHTS = [
  "Browse public AI porn templates instead of starting from a blank prompt every time.",
  "Use undress AI and nudify-compatible image edits on supported templates.",
  "Turn still images into motion with image-to-video and NSFW AI video workflows.",
  "Save and repeat setups for AI girlfriend-style characters and recurring ideas.",
];

const PRODUCT_OVERVIEW = [
  "Instead of forcing every visitor to start from zero, Fapify connects template discovery, AI porn image creation, compatible image editing, and short-form NSFW video generation inside one platform.",
  "That makes it easier to move from idea to output without bouncing between separate tools or rebuilding the same workflow every time.",
];

const REPEATABLE_WORKFLOWS = [
  "Fapify is built for repeatable creation rather than one-off prompt experiments. Once you find a setup that works, you can keep using it for new still images, short clips, and recurring character-style ideas.",
  "The product is strongest when you treat the workflow as a sequence: template first, refinement second, motion last.",
];

const HomeSeoAccordions = () => {
  const [overviewOpen, setOverviewOpen] = useState(false);
  const [faqOpen, setFaqOpen] = useState(false);
  const overviewId = useId();
  const faqId = useId();

  return (
    <>
      <AccordionSection>
        <AccordionCard>
          <ToggleButton
            type="button"
            aria-expanded={overviewOpen}
            aria-controls={overviewId}
            onClick={() => setOverviewOpen((open) => !open)}
          >
            <AccordionTitle>AI Porn Generator</AccordionTitle>
            <ToggleIcon $open={overviewOpen} aria-hidden="true" />
          </ToggleButton>

          <AccordionContent id={overviewId} $open={overviewOpen}>
            <AccordionContentInner $open={overviewOpen}>
              <AccordionLead>
                Fapify is an AI porn generator with public AI porn templates,
                undress AI, image-to-video workflows, nudify-compatible edits,
                NSFW AI tools, and reusable AI girlfriend-style workflows.
              </AccordionLead>

              <AccordionBlock>
                <AccordionSubtitle>Start Here</AccordionSubtitle>
                <HeroActions>
                  <PrimaryLink to="/ai-porn-generator">
                    AI Porn Generator
                  </PrimaryLink>
                  <SecondaryLink to="/ai-porn-video-generator">
                    AI Porn Videos
                  </SecondaryLink>
                  <SecondaryLink to="/nsfw-ai">NSFW AI</SecondaryLink>
                </HeroActions>
              </AccordionBlock>

              <AccordionBlock>
                <AccordionSubtitle>What You Can Do</AccordionSubtitle>
                <AccordionList>
                  {PRODUCT_HIGHLIGHTS.map((item) => (
                    <AccordionListItem key={item}>{item}</AccordionListItem>
                  ))}
                </AccordionList>
              </AccordionBlock>

              <AccordionBlock>
                <AccordionSubtitle>
                  Why Fapify Feels Easier to Use
                </AccordionSubtitle>
                {PRODUCT_OVERVIEW.map((paragraph) => (
                  <AccordionText key={paragraph}>{paragraph}</AccordionText>
                ))}
              </AccordionBlock>

              <AccordionBlock>
                <AccordionSubtitle>
                  Built for Repeatable Workflows
                </AccordionSubtitle>
                {REPEATABLE_WORKFLOWS.map((paragraph) => (
                  <AccordionText key={paragraph}>{paragraph}</AccordionText>
                ))}
              </AccordionBlock>
            </AccordionContentInner>
          </AccordionContent>
        </AccordionCard>
      </AccordionSection>

      <AccordionSection>
        <AccordionCard>
          <ToggleButton
            type="button"
            aria-expanded={faqOpen}
            aria-controls={faqId}
            onClick={() => setFaqOpen((open) => !open)}
          >
            <AccordionTitle>FAQs</AccordionTitle>
            <ToggleIcon $open={faqOpen} aria-hidden="true" />
          </ToggleButton>

          <AccordionContent id={faqId} $open={faqOpen}>
            <AccordionContentInner $open={faqOpen}>
              {HOME_FAQS.map((item) => (
                <AccordionBlock key={item.question}>
                  <AccordionSubtitle>{item.question}</AccordionSubtitle>
                  <AccordionText>{item.answer}</AccordionText>
                </AccordionBlock>
              ))}
            </AccordionContentInner>
          </AccordionContent>
        </AccordionCard>
      </AccordionSection>
    </>
  );
};

export default HomeSeoAccordions;
